import {createLogger} from "@gongt/ts-stl-library/log/debug";
import {LOG_LEVEL} from "@gongt/ts-stl-library/log/levels";
import {Request} from "express-serve-static-core";
import {
	LIBRARY_LOGIN_COOKIE_NAME,
	PACKAGE_LOGIN_COOKIE_NAME,
	PACKAGE_LOGIN_HEADER_NAME,
	REFRESH_TOKEN_GET_PARAM_NAME,
} from "../bridge/const";
import {UserError} from "../includes/user-error";

const debug = createLogger(LOG_LEVEL.DEBUG, 'get token');

export function tryGetTokenFromRequest(req: Request) {
	let userToken: string, safe: boolean = false;
	debug('try get user token:');
	// console.log(req.query,req.cookies,req.signedCookies)
	if (req.query && (req.query.token || req.query[REFRESH_TOKEN_GET_PARAM_NAME])) {
		userToken = req.query.token || req.query[REFRESH_TOKEN_GET_PARAM_NAME];
		debug('\tfound in query string. token');
	} else if (req.signedCookies && req.signedCookies[LIBRARY_LOGIN_COOKIE_NAME]) {
		userToken = req.signedCookies[LIBRARY_LOGIN_COOKIE_NAME];
		debug('\tfound in signed cookies. %s', LIBRARY_LOGIN_COOKIE_NAME);
		safe = true;
	} else if (req.header(PACKAGE_LOGIN_HEADER_NAME)) {
		userToken = req.header(PACKAGE_LOGIN_HEADER_NAME) as string;
		debug('\tfound in header. %s', PACKAGE_LOGIN_HEADER_NAME);
	} else if (req.cookies && req.cookies[PACKAGE_LOGIN_COOKIE_NAME]) {
		userToken = req.cookies[PACKAGE_LOGIN_COOKIE_NAME];
		debug('\tfound in cookies. %s', PACKAGE_LOGIN_COOKIE_NAME);
	}
	if (!userToken) {
		debug('no token, throw `require login` error');
		throw new UserError('require login');
	}
	debug('token: %s [%s]', userToken, typeof userToken);
	
	return {token: userToken, safe};
}
